import {ReactNode} from "react";
import {useFormContext} from "react-hook-form";

import {useNavigationBlocker} from "@/lib/hooks/useNavigationBlocker.tsx";

interface UseUnsavedChangesBlockerProps {
  onDiscard: () => void;
}

interface UseUnsavedChangesBlockerReturn {
  blockOrDiscard: () => void;
  UnsavedChangesModal: () => ReactNode;
}

export const useUnsavedChangesNavigationBlocker = ({
  onDiscard,
}: UseUnsavedChangesBlockerProps): UseUnsavedChangesBlockerReturn => {
  const {formState} = useFormContext();
  const shouldBlock = formState.isDirty && !formState.isSubmitSuccessful;

  const {showBlockerModal, NavigationBlockerModal} = useNavigationBlocker({
    shouldBlock,
    onConfirm: onDiscard,
    onUnblocked: onDiscard,
  });

  return {
    blockOrDiscard: showBlockerModal,
    UnsavedChangesModal: NavigationBlockerModal,
  };
};
